import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientesViewComponent } from './clientes-view.component';
import { PoModule } from '@po-ui/ng-components';



@NgModule({
  declarations: [ClientesViewComponent],
  imports: [
    CommonModule, PoModule
  ]
})
export class clientesViewModule { }
